<template>
   <li class="k-item" @click="handleClick">
      <span>
         {{ dataItem?.name }}
      </span>
   </li>
</template>
<script>
export default {
   emits: {
      click: null
   },
   props: {
      dataItem: Object,
      textField: String,
      focused: Boolean,
      selected: Boolean,
   },
   methods: {
      handleClick(e) {
         this.$emit('click', e);
      }
   }
}
</script>